export const blogs = [
{
    id: 1,
    img:"https://i.picsum.photos/id/3/5616/3744.jpg?hmac=QSuBxtSpEv3Qm3iStn2b_Ikzj2EVD0jzn99m1n6JD9I",
    link:"https://edademiray.medium.com/dijital-pazarlamada-i%CC%87%C5%9F-f%C4%B1rsatlar%C4%B1-4419823a8639"

},
{
    id: 2,
    img:"https://i.picsum.photos/id/180/2400/1600.jpg?hmac=Ig-CXcpNdmh51k3kXpNqNqcDYTwXCIaonYiBOnLXBb8",
    link:"https://edademiray.medium.com/dijital-pazarlamada-i%CC%87%C5%9F-f%C4%B1rsatlar%C4%B1-4419823a8639",
    
},{
    id: 3,
    img:"https://i.picsum.photos/id/201/5184/3456.jpg?hmac=3SX-1t9hHlAmc653Ox-EmJonZBCaCSK5b9FayvY4sbI",
    link:"https://edademiray.medium.com/dijital-pazarlamada-i%CC%87%C5%9F-f%C4%B1rsatlar%C4%B1-4419823a8639",
    
}
];